import styled from 'styled-components';

export const AddUserForm = styled.form`
  margin-top: 20px;
  display: grid;
  grid-template-columns: 100%;
  gap: 20px;
`;
